import { render, staticRenderFns } from "./TransportLogTable.vue?vue&type=template&id=1df46e39"
import script from "./TransportLogTable.vue?vue&type=script&lang=ts"
export * from "./TransportLogTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports